import { Protocol } from '../Protocol';

export class VehicleProtocol {
  public static readonly PAGINATION_VEHICLE: string = `${Protocol.YATUNG_API_ROOT}/vehicle/V2/p/all`;
  public static readonly GET_VEHICLE_BY_ID: string = `${Protocol.YATUNG_API_ROOT}/vehicle/V2`;
}
